import { api } from '../../../../components/common';
import { 
  NoteWithDetails,
  CreateNoteRequest,
  UpdateNoteRequest,
  NoteSearchParams,
  PaginatedNotesResponse
} from '../types';

export const notesApi = {
  getAll: (params: NoteSearchParams = {}): Promise<PaginatedNotesResponse> => {
    const queryParams = new URLSearchParams();

    if (params.search) queryParams.append('search', params.search);
    if (params.page) queryParams.append('page', params.page.toString());
    if (params.limit) queryParams.append('limit', params.limit.toString());
    if (params.typeId) queryParams.append('typeId', params.typeId.toString());
    if (params.priorityId) queryParams.append('priorityId', params.priorityId.toString());
    if (params.tagId) queryParams.append('tagId', params.tagId.toString());
    if (params.contactId) queryParams.append('contactId', params.contactId.toString());
    if (params.propertyId) queryParams.append('propertyId', params.propertyId.toString());
    if (params.expenseId) queryParams.append('expenseId', params.expenseId.toString());
    if (params.dateFrom) queryParams.append('dateFrom', params.dateFrom);
    if (params.dateTo) queryParams.append('dateTo', params.dateTo);

    if (params.fields && params.fields.length > 0) {
      queryParams.append('fields', JSON.stringify(params.fields));
    }

    if (params.sorts && params.sorts.length > 0) {
      const sortsPayload = params.sorts.map(sort => ({
        field: sort.field,
        direction: sort.direction
      }));
      queryParams.append('sorts', JSON.stringify(sortsPayload));
    }

    // Legacy parameters for compatibility
    if (params.query) queryParams.append('query', params.query);
    if (params.field) queryParams.append('field', params.field);
    if (params.sortBy) queryParams.append('sortBy', params.sortBy);
    if (params.sortDirection) queryParams.append('sortDirection', params.sortDirection);

    const queryString = queryParams.toString();
    const url = queryString ? `/notes?${queryString}` : '/notes';

    return api.get(url).then(res => res.data);
  },
    
  getById: (id: number): Promise<NoteWithDetails> =>
    api.get(`/notes/${id}`).then(res => res.data),
    
  create: (note: CreateNoteRequest): Promise<NoteWithDetails> =>
    api.post('/notes', note).then(res => res.data),
    
  update: (id: number, note: UpdateNoteRequest): Promise<NoteWithDetails> =>
    api.put(`/notes/${id}`, note).then(res => res.data),
    
  delete: (id: number): Promise<void> =>
    api.delete(`/notes/${id}`).then(() => {}),

  getByEntityId: (entityType: 'contact' | 'property' | 'expense', entityId: number): Promise<NoteWithDetails[]> =>
    api.get(`/notes/${entityType}/${entityId}`).then(res => res.data),
};

